export default "<template>\n\n  <KButton\n    text=\"Flat Button\"\n    appearance=\"flat-button\"\n  />\n\n</template>\n";